import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import ColorPaletteComponent from "./ColorPaletteComponent";

const ColorPalettePage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox title={"Colors"} description={""} />
      <Divider light />
      <ColorPaletteComponent />
    </Paper>
  );
};

export default ColorPalettePage;
